import React from 'react';

const RevolutionSection = () => {
  return (
    <section className="w-full bg-white py-12 md:py-16">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex flex-col items-center">
          <video
            autoPlay
            muted
            loop
            playsInline
            controls
            className="w-full max-w-4xl h-auto rounded-lg shadow-xl"
          >
            <source 
              src="https://customer-assets.emergentagent.com/job_prysm-replica/artifacts/4xgj5l2b_Prysm%20iO%20Overview%20December%2017%2C%202025%20Dr.%20Stephen%20Moore%20and%20Dr.%20Dan%20McDyer%20Functional%20OBGyn-1854x1080-avc1-mp4a.mp4" 
              type="video/mp4" 
            />
            Your browser does not support the video tag.
          </video>
          
          {/* Text below video */}
          <div className="mt-8 text-center">
            <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
              Science & Business Overview
            </h3>
            <p className="text-gray-600 text-lg">
              by Stephen Moore, DC & Andy Feltz, OD
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RevolutionSection;
